import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./user/userSlice";
import courseSlice from "./course/courseSlice";
import coursesSlice from "./courses/coursesSlice";
import settingsSlice from "./settings/settingsSlice";

export const store = configureStore({
  reducer: {
    user: userSlice,
    courses: coursesSlice,
    course: courseSlice,
    settings: settingsSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
